import React, { useEffect, useRef, useState } from "react";
import { ListBox } from 'primereact/listbox';
import { SelectButton } from 'primereact/selectbutton';
import { InputMask } from "primereact/inputmask";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Tree } from 'primereact/tree';
import kpiService from "@services/kpi.service";
import performanceManagementService from "@services/performanceManagement.service";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ColorPicker } from 'primereact/colorpicker';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { TreeSelect } from 'primereact/treeselect';
import { InputText } from 'primereact/inputtext';
import useLocalStorage from "src/hooks/useLocalStorage";
import { Slider } from 'primereact/slider';
import strftime from "strftime";
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { SplitButton } from 'primereact/splitbutton';
import { TabView, TabPanel } from 'primereact/tabview';
import RadioGroupBtn from 'src/components/RadioGroupBtn';
import { InputNumber } from 'primereact/inputnumber';
import { useImmer } from 'use-immer'
import { Message } from 'primereact/message';
import { InputSwitch } from 'primereact/inputswitch';
import { MultiStateCheckbox } from 'primereact/multistatecheckbox';
// import "src/styles/theme.css";


import { Sidebar } from 'primereact/sidebar';

import * as Papa from 'papaparse';
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Queries2() {
  const [selectedNodes, setselectedNodes] = useState(null);

  const [lines, setLines] = useState({ left1: [], left2: [], right1: [], right2: [], bottom1: [], bottom2: [] });
  const [drawLine, setDrawLine] = useState("secondary");

  const [lineValue, setLineValue] = useState("");
  const [selectePoint, setSelectePointe] = useState([]);
  const [newLineName, setNewLineName] = useState("No Name");
  const [newLineColor, setNewLineColor] = useState("ff0000");
  const [newLineDashStyle, setNewLineDashStyle] = useState({ name: "Solid" });
  const [newLineFontSize, setNewLineFontSize] = useState(1.2);
  const [newLineWidth, setNewLineWidth] = useState(2);
  const [showLineDialog, setShowLineDialog] = useState(false);
  const [showDahboardDialog, setShowDahboardDialog] = useState(false);
  const [selectedKPI, setSelectedKPI] = useState(null);
  const [kpiList, setKpiList] = useState([]);
  const [startDate, setStartDate] = useState(new Date(new Date() - (7 * 86400000)));
  const [endDate, setEndDate] = useState(new Date());
  const [endDateVisible, setEndDateVisible] = useState(false);
  const [startDateVisible, setStartDateVisible] = useState(false);
  const [charts, setCharts] = useState({});
  const [chartsList, setChartsList] = useState([]);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [timeDialogVisible, setTimeDialogVisible] = useState(false);
  const [nodeFilterValue, setNodeFilterValue] = useState('');
  const [treeValue, setTreeValue] = useState('');
  const [timeSpan, setTimeSpan] = useState('');
  const [collapse, setCollapse] = useLocalStorage("plano-menu-collapse", false);
  // filterMatchMode
  const [filterMatchMode, setFilterMatchMode] = useState('contains');
  const toast = useRef(null);
  const [lineLabel, setLineLabel] = useImmer({
    align: { name: "left" },
    text: "No Name",
    x: 0,
    y: 0,
    verticalAlign: { name: "top" }
  })
  const kpi_category = useRef({});
  const ag_items = [
    // { name: '15 min', value: "15m" },
    // { name: '30 min', value: "30m" },
    { name: 'Hourly', value: "1h" },
    { name: 'Daily', value: "1d" },
    { name: 'Weekly', value: "1w" },
  ];
  const [value_ag, setag] = useState({ name: 'Daily', value: "1d" });
  const times = [
    { name: '00' },
    { name: '01' },
    { name: '02' },
    { name: '03' },
    { name: '04' },
    { name: '05' },
    { name: '06' },
    { name: '07' },
    { name: '08' },
    { name: '09' },
    { name: '10' },
    { name: '11' },
    { name: '12' },
    { name: '13' },
    { name: '14' },
    { name: '15' },
    { name: '16' },
    { name: '17' },
    { name: '18' },
    { name: '19' },
    { name: '20' },
    { name: '21' },
    { name: '22' },
    { name: '23' },
  ];
  const [selectedTimes, setSelectedTimes] = useState([...times]);

  const [nodes, setNodes] = useState([]);
  const [tree, setTree] = useState([]);
  const [selectedKey, setSelectedKey] = useState('');
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setTree([
      {
        key: 'H3G',
        label: 'H3G',
        icon: 'pi pi-fw pi pi-fw pi-database',
        children: [
          // { key: 'huawei-3g-REGION', label: 'Region', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-UMTS-Province', label: 'UMTS-Province', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-UMTS-City', label: 'UMTS-City', icon: 'pi pi-fw pi-file' },
          // { key: 'huawei-UMTS-CLUSTER', label: 'UMTS-Cluster', icon: 'pi pi-fw pi-file' },
          // { key: 'huawei-UMTS-ZONES', label: 'UMTS-Zone', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-UMTS-Site', label: 'UMTS-Site', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-UMTS-Sector', label: 'UMTS-Sector', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-UMTS-NAME', label: 'UMTS-Cell', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-UMTS-Carrier', label: 'UMTS-Band', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-UMTS-RNC', label: 'UMTS-RNC', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-UMTS-Cluster', label: 'UMTS-Cluster', icon: 'pi pi-fw pi-file' },
        ]
      },
      {
        key: 'H4G',
        label: 'H4G',
        icon: 'pi pi-fw pi-database',
        children: [
          // { key: 'huawei-4g-REGION', label: 'Region', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-LTE-Province', label: 'LTE-Province', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-LTE-City', label: 'LTE-City', icon: 'pi pi-fw pi-file' },
          // { key: 'huawei-LTE-CLUSTER', label: 'LTE-Cluster', icon: 'pi pi-fw pi-file' },
          // { key: 'huawei-LTE-ZONES', label: 'LTE-Zone', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-LTE-Site', label: 'LTE-Site', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-LTE-Sector', label: 'LTE-Sector', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-LTE-NAME', label: 'LTE-Cell', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-LTE-Carrier', label: 'LTE-Band', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-LTE-RNC', label: 'LTE-RNC', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-LTE-Cluster', label: 'LTE-Cluster', icon: 'pi pi-fw pi-file' },
        ]
      },
      {
        key: 'Custom',
        label: 'Custom',
        icon: 'pi pi-fw pi-database',
        children: [
          // { key: 'huawei-4g-REGION', label: 'Region', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-Custom-Province', label: 'Custom-Province', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-Custom-City', label: 'Custom-City', icon: 'pi pi-fw pi-file' },
          // { key: 'huawei-Custom-CLUSTER', label: 'Custom-Cluster', icon: 'pi pi-fw pi-file' },
          // { key: 'huawei-Custom-ZONES', label: 'Custom-Zone', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-Custom-Site', label: 'Custom-Site', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-Custom-Sector', label: 'Custom-Sector', icon: 'pi pi-fw pi-file' },
          { key: 'huawei-Custom-RNC', label: 'Custom-RNC', icon: 'pi pi-fw pi-file' },

          // { key: 'huawei-Custom-NAME', label: 'Custom-Cell', icon: 'pi pi-fw pi-file' },

        ]
      }
    ]);
    let days = 86400000;
    let today = new Date();
    let before = new Date(today - (7 * days));
    chartRef.current.chart.showLoading();
    // setStartDate(strftime('%F', before));
    // setEndDate(strftime('%F', today));
  }, []);

  const options = {
    exporting: {
      enabled: true,
      width: 1920
    },
    title: {
      text: "",
      align: 'left'
    },
    chart: {
      zoomType: "xy",
      style: {
        //   fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
        // "Helvetica Neue", Arial, "Noto Sans", sans-serif,
        // "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
        height: "100%"
      },
      exporting: {
        enabled: false,
      },
      events: {
        click: function (e) {
          if (drawLine === "success") {
            let options = [];
            for (let index = 0; index < e.xAxis.length; index++) {
              const x = e.xAxis[index];
              console.log(x);
              if (x.value) {
                options.push({
                  "name": "Vertical : " + Highcharts.dateFormat('%Y-%m-%d %H:%M', x.value),
                  "tvalue": x.value,
                  "Target": x.axis.userOptions.id,
                  "ax": "xAxis",
                  "ax_index": index
                })
              }
            }
            const defaultVerticalOption = options.find(option => option.name.startsWith('Vertical'));

            if (defaultVerticalOption) {
              setLineOrientation(defaultVerticalOption);
            }
            for (let index = 0; index < e.yAxis.length; index++) {
              const y = e.yAxis[index];
              if (y.value) {
                options.push({
                  "name": "Horizontal : " + y.value,
                  "tvalue": y.value,
                  "Target": y.axis.userOptions.id,
                  "ax": "yAxis",
                  "ax_index": index

                })
              }
            }
            console.log(
              options
            );
            setSelectePointe(options);
            setShowLineDialog(true);
          }

        }
      }
      ,
    },
    credits: {
      enabled: false,
    },
    // colors: ["#2F5EC4", "#45a5f5"],
    plotOptions: {
      line: {
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 3,
          },
        },
        marker: {
          enabled: false,
        },
      },
      spline: {
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 3,
          },
        },
        marker: {
          enabled: false,
        },
      },
      series: {
        allowPointSelect: true,
        softThreshold: false,
        dataLabels: {
          // enabled: true,
          // formatter: function () {
          //   var dataMax = this.series.dataMax;
          //   if (this.y === dataMax) {
          //     return this.y;
          //   }
          // },
        },
        // cursor: 'pointer',
        // point: {
        //   events: {
        //     click: function () {
        //       // console.log(this, this.series.sharedClipKey);
        //       // setSelectePointe(this.x);
        //       // setShowLineDialog(true);
        //       //call function passin;g this values as arguments
        //     }
        //   }
        // }
      },
    },
    time: {
      // useUTC: false,
      // timezone: "Asia/Tehran",
      timezoneOffset: -270,
    },
    yAxis: [
      {
        id: "left1",
        plotLines: lines["left1"],
        lineWidth: 1,
        oppoSite: false,
        title: {
          enabled: false,
        }
      },
      {
        id: "left2",
        plotLines: lines["left2"],
        oppoSite: true,
        title: {
          enabled: false,
        },
      },
      {
        id: "right1",
        plotLines: lines["right1"],
        oppoSite: true,
        title: {
          enabled: false,
        },
      },
      {
        id: "right2",
        plotLines: lines["right2"],
        oppoSite: true,
        title: {
          enabled: false,
        },
      },
    ],
    xAxis: [
      {
        id: "bottom1",
        type: "datetime",
        labels: {
          style: { fontWeight: "bold" },
          rotation: 90,
          // format: ""
        },
        lineWidth: 1,

        plotLines: lines["bottom1"],
        title: {
          enabled: false,
        },
      },
      {
        id: "bottom2",
        type: "datetime",
        labels: {
          style: { fontWeight: "bold" },
          rotation: 90,
          // format: ""
        },
        lineWidth: 1,
        plotLines: lines["bottom2"],
        title: {
          enabled: false,
        },
      },
    ],
    tooltip: {
      shared: false,
      crosshairs: true,
    },

    //   legend: {
    //     layout: 'vertical',
    //     align: 'center',
    //     verticalAlign: 'down'
    // },
    series: [

    ],
  };
  const chartRef = useRef(null);
  const calendarStartRef = useRef(null);
  const calendarEndRef = useRef(null);
  const onCategoryChange = (e) => {
    let _selectedTimes = [...selectedTimes];
    // console.log(e);
    if (e.checked)
      _selectedTimes.push(e.value);
    else
      _selectedTimes = _selectedTimes.filter(category => category.name !== e.value.name);

    setSelectedTimes(_selectedTimes);
  };
  const addNewChartToDashboard = () => {
    let sections = [];
    for (const chart of chartsList) {
      sections.push({
        bucket: chart.bucket,
        color: chart.color,
        kpi: chart.kpi,
        node: chart.node,
        tech: chart.tech,
        type: chart.type,
        xAxis: chart.xAxis,
        yAxis: chart.yAxis,
        scope: chart.scope,
        times: chart.times,
      })
    }
    let data = {
      sections: sections,
      dashboardName: selectedDashboard.name ? selectedDashboard.name : selectedDashboard,
      dashboardID: selectedDashboard.name ? selectedDashboard._id : null,
      sectionName: sectionName,
      sectionDuration: sectionDuration
    }
    if (sections.length > 0) {
      performanceManagementService.rightel_dashboard_addSection(data).then(response => {
        toast.current.show({ severity: 'info', summary: 'Message', detail: 'Section saved' });
      }).catch(error => {
        console.log(error);
        toast.current.show({ severity: 'warning', summary: 'Error Message', detail: 'Save Dashboard Error!' });
      })
    }
    else {
      toast.current.show({ severity: 'info', summary: 'Error Message', detail: 'Run a Query!' });
    }
    // console.log("done");
    setSectionName("")
    setSelectedDashboard("")
    setShowDahboardDialog(false);

  };
  const nodeOnFilterValueChange = (filter) => {
    // console.log(filter);
    setNodeFilterValue(filter);
  }
  const dialogFooterTemplate = () => {
    return <Button className="h-9 text-sm " label="Ok" icon="pi pi-check" onClick={() => setDialogVisible(false)} />;
  };

  const dialogTimeFooterTemplate = (
    <div>
      {/* <Button label="All" icon="pi pi-check-square" onClick={() => setTimeDialogVisible(false)} className="p-button-text" /> */}
      <Button className="h-9 text-sm " label="All" icon="pi pi-circle-fill" onClick={() => setSelectedTimes([...times])} />
      <Button className="h-9 text-sm " label="None" icon="pi pi-circle" onClick={() => setSelectedTimes([])} />
      <Button className="h-9 text-sm " label="Ok" icon="pi pi-check" onClick={() => setTimeDialogVisible(false)} />
    </div>
  );
  const dialogLineFooterTemplate = () => {
    return <Button className="h-9 text-sm " label="Ok" icon="pi pi-check" onClick={addNewLine} />;
  };
  const dialogSaveChartToDashboard = () => {
    return <Button className="h-9 text-sm " label="Ok" icon="pi pi-check" onClick={addNewChartToDashboard} />;
  };
  const colorTemplate = (rowData) => {
    return (
      <ColorPicker value={rowData.color} onChange={(e) => onColorChange(e, rowData)} />
    );
  };
  const yAxisTemplate = (rowData) => {
    return (
      <Dropdown className="h-10 w-34 text-xs" optionLabel="label" value={rowData.yAxis} options={yAxisSelectItems} onChange={(e) => onYAxisChange(e, rowData)} />
    );
  };
  const deleteTemplate = (rowData) => {
    return (
      <Button icon="pi pi-times" onClick={() => onDelete(rowData)} className="p-button-rounded p-button-danger p-button-text" />
    );
  };
  const exportTemplate = (rowData) => {
    return (
      <Button icon="pi pi-download" onClick={() => onDownload(rowData)} className="p-button-rounded p-button-danger p-button-text" />
    );
  };
  const [checkedSelectAll, setCheckedSelectAll] = useState(false);
  const [checkedAggregate, setCheckedAggregate] = useState(false);


  const xAxisTemplate = (rowData) => {
    return (
      <Dropdown className="h-10 w-34 text-xs" optionLabel="label" value={rowData.xAxis} options={xAxisSelectItems} onChange={(e) => onXAxisChange(e, rowData)} />
    );
  };
  const onDownload = (rowData) => {
    // console.log(rowData);
    let data = {
      "buket": rowData.bucket,
      "startDate": rowData.startDate,
      "endDate": rowData.endDate,
      "ne_list": rowData.node,
      "kpi_id": rowData.id.split("|")[2],
      "scope": rowData.id.split("|")[6],
      "tech": rowData.tech,
      "times": rowData.times
    };
    performanceManagementService.Post("/v2/kpir", data).then((response) => {
      const href = URL.createObjectURL(new Blob([response.data],
        { type: 'application/x-zip-compressed' }));

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', 'export.zip'); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
  };
  const onDelete = (rowData) => {
    // console.log("rowData.id2", rowData)
    let [node, kpi] = rowData.id.split("-");
    let newChartlist = chartsList.filter(p => p.id !== rowData.id);
    setChartsList(newChartlist);
    // setNodes(newNodes);
    charts[rowData.id].remove();
    delete charts[rowData.id]
  };
  const onColorChange = (e, rowData) => {
    // console.log(e,rowData);
    charts[rowData.id].update({ color: "#" + e.value });
    rowData.color = "#" + e.value;
  };

  const xAxisEditor = (props) => {
    return (
      <Dropdown value={props.rowData["xAxis"]} options={xAxisSelectItems}
        onChange={(e) => onXAxisChange(props, e.value)} style={{ width: '100%' }}
        itemTemplate={(option) => {
          return <span className={`product-badge status-${option.value.toLowerCase()}`}>{option.label}</span>
        }} />
    );
  }
  const minMaxEditor = (props, name) => {
    return (
      <InputNumber value={props.rowData[name]} onValueChange={(e) => onMinMaxChange(props, name, e.value)} />
    );
  }
  const onChartClick = (e) => {
    console.log(e)
  }
  const onMinMaxChange = (props, name, value) => {

    for (const cl of chartsList) {
      if (cl.yAxis === props.rowData.yAxis) {
        cl[name] = value;
      }
    }
    setChartsList(chartsList);
    // console.log("ccccc", chartRef.current.chart)
    let currentY = chartRef.current.chart.yAxis.filter(p => p.userOptions.id === props.rowData.yAxis);
    // console.log(currentY)
    if (currentY.length === 1) {
      if (name === "min") {
        currentY[0].setExtremes(value, props.rowData.max);
      }
      else {
        currentY[0].setExtremes(props.rowData.min, value);
      }

    }

  }
  const [showAllSeries, setShowAllSeries] = useState(false);

  const toggleSeriesVisibility = () => {
    // Get the chart instance
    const chart = chartRef.current.chart;

    // Toggle visibility for all series
    chart.series.forEach((series) => {
      series.setVisible(showAllSeries, false);
    });

    // Redraw the chart only once
    // chart.redraw();

    // Update the button label
    setShowAllSeries(!showAllSeries);

  };
  const onXAxisChange = (props, value) => {
    chartsList[props.rowIndex].xAxis = value;
    setChartsList(chartsList);
    charts[props.rowData.id].update({ xAxis: value });
  }
  const typeEditor = (props) => {
    return (
      <Dropdown value={props.rowData["type"]} options={chartTypes}
        onChange={(e) => onTypeChange(props, e.value)} style={{ width: '100%' }}
        itemTemplate={(option) => {
          return <span className={`product-badge status-${option.value.toLowerCase()}`}>{option.label}</span>
        }} />
    );
  }
  const onTypeChange = (props, value) => {
    chartsList[props.rowIndex].type = value;
    setChartsList(chartsList);
    charts[props.rowData.id].update({ type: value });
  }
  const yAxisEditor = (props) => {
    return (
      <Dropdown value={props.rowData["yAxis"]} options={yAxisSelectItems}
        onChange={(e) => onYAxisChange(props, e.value)} style={{ width: '100%' }}
        itemTemplate={(option) => {
          return <span className={`product-badge status-${option.value.toLowerCase()}`}>{option.label}</span>
        }} />
    );
  }
  const addNewLine = () => {
    if (!lineOrientation || !lineOrientation.name) {
      toast.current.show({ severity: 'info', summary: 'Error Message', detail: 'Select Orientation' });
    } else {

      let x = { ...lines };
      // x = x.concat(xlines);
      console.log("lineLabel", lineLabel);
      x[lineOrientation.Target].push({
        color: "#" + newLineColor, // Color value
        dashStyle: newLineDashStyle.name, // Style of the plot line. Default to solid
        value: lineOrientation.tvalue, // Value of where the line will appear
        width: newLineWidth,// Width of the line    
        label: {
          text: lineLabel.text,
          style: { fontWeight: "bold", fontSize: '1.2em' },
          rotation: 0,
          x: lineLabel.x,
          y: lineLabel.y,
          align: lineLabel.align.name,
          verticalAlign: lineLabel.verticalAlign.name
        },
        id: lineOrientation.tvalue,
        zIndex: 100,
        events: {
          click: (x) => {
            // console.log(selectePoint);
            // "ax":"xAxis",
            // "ax_index":index
            chartRef.current.chart[lineOrientation.ax][lineOrientation.ax_index].removePlotLine(lineOrientation.tvalue);
          },

        }
      });
      setShowLineDialog(false);
      setLineOrientation(null);
      setLines(x);
    }
  }
  const onYAxisChange = (props, value) => {
    console.log(props);
    console.log(value);
    chartsList[props.rowIndex].yAxis = value;
    setChartsList(chartsList);
    charts[props.rowData.id].update({ yAxis: value });
  }

  const yAxisSelectItems = [
    { label: 'Left 1', value: 'left1' },
    { label: 'Left 2', value: 'left2' },
    { label: 'Right 1', value: 'right1' },
    { label: 'Right 2', value: 'right2' },
  ];

  const xAxisSelectItems = [
    { label: 'Bottom 1', value: 'bottom1' },
    { label: 'Bottom 2', value: 'bottom2' },
  ];
  const chartTypes = [
    { label: 'spline', value: 'spline' },
    { label: 'line', value: 'line' },
    { label: 'bar', value: 'bar' },
    { label: 'area', value: 'area' },
    { label: 'column', value: 'column' },
  ];
  const clearChart = (e) => {
    for (const chartName in charts) {
      charts[chartName].remove(false);
      // delete charts[chartName];
    }
    setCharts({});
    setChartsList([]);
    // setselectedNodes([]);
    setSelectedKPI([]);
    // setCheckedAggregate(false);
    // setCheckedSelectAll(false);
  }
  const [downloadLoading, setdownloadLoading] = useState(false);
  const [playLoading, setPlayLoading] = useState(false);

  const FetchKpi = () => {
    let start = new Date();
    // console.log(selectedNodes>0 , selectedKPI.length>0 , Date.parse(startDate) , Date.parse(endDate) , value_ag.value)
    if (selectedNodes.length > 0 && selectedKPI.length > 0 && Date.parse(startDate) && Date.parse(endDate) && value_ag.value) {
      if (selectedNodes.length > 31 && !checkedAggregate) {
        toast.current.show({ severity: 'info', summary: 'Error Message', detail: 'ne must be less than 30' });
      }
      else {
        const [vendor, tech, level] = selectedKey.split("-");
        const start_mini = strftime("%m-%d", new Date(startDate));
        const end_mini = strftime("%m-%d", new Date(endDate));
        const date_mini = start_mini + "|" + end_mini;
        // console.log(startDate);
        // let newNodes = arr1.filter(x => !arr2.includes(x));
        // for (const chartName in charts) {
        //   let [tech, node_name, kpi_name] = chartName.split("|");
        //   // console.log("xnew chart charts", [tech, node_name, kpi_name]);
        //   if (selectedKPI.filter(p => p.name === kpi_name).length === 0 || selectedNodes.indexOf(node_name) === -1) {
        //     // console.log("chartName", chartName);
        //     charts[chartName].remove();
        //     delete charts[chartName];
        //   }
        // }
        let newNode = new Set();
        let newKPI = new Set();
        for (const kpi of selectedKPI) {
          for (const node of selectedNodes) {
            const chartName = tech + "|" + node + "|" + kpi.name + "|" + value_ag.value + "|" + date_mini + "|" + level;
            // console.log("xnew chart charts", charts);
            // console.log("xnew chart", chartName);
            if (chartName in charts) {
              // console.log("chartNamefOUND", chartName);
            }
            else {
              newNode.add(node);
              newKPI.add(kpi);
            }
          }
        }
        // console.log(selectedTimes);
        if (newNode.size !== 0 && newKPI.size !== 0) {
          let times = []
          selectedTimes.forEach(d => times.push(d.name));
          let data = {
            "buket": value_ag.value,
            "startDate": startDate,
            "endDate": endDate,
            "scope": level,
            "ne_list": Array.from(newNode),
            "kpi_id": Array.from(newKPI),
            "tech": tech,
            "times": times,
            "ag": checkedAggregate
          };
          // console.log(data);
          // console.log("newKPI", newKPI);
          chartRef.current.chart.showLoading();
          setPlayLoading(true);
          performanceManagementService.Post("/v2/kpir", data).then((response) => {
            chartRef.current.chart.hideLoading();
            let end = new Date();
            let timeSpan = end - start;
            setTimeSpan(`Ops! Query took ${timeSpan} milliseconds`);
            setPlayLoading(false);
            if (response.data.length === 0) {
              toast.current.show({ severity: 'info', summary: 'Message', detail: 'Data not found' });
            }
            for (const chart_data of response.data) {
              // console.log("chart_data.name", chart_data.name);
              let chartYaxis = "left1";
              // console.log("dddddd", chart_data.data[0][1]);
              if (chart_data.data[0][1] && chart_data.data[0][1] >= 10 && chart_data.data[0][1] < 101) {
                chartYaxis = "left1";
              }
              else if (chart_data.data[0][1] && chart_data.data[0][1] < 10) {
                chartYaxis = "left2";
              }
              else if (chart_data.data[0][1] && chart_data.data[0][1] < 0) {
                chartYaxis = "right1";
              }
              else {
                chartYaxis = "right2";
              }
              charts[chart_data.name] = chartRef.current.chart.addSeries({
                type: "spline",
                // id: chart_data.name,
                visible: true,
                yAxis: chartYaxis,
                xAxis: "bottom1",
                name: chart_data.name,
                // color: counter.color,
                data: chart_data.data
              });

              //   charts[chart_data.name].yAxis.update({
              //     oppoSite: oppoSite
              // });
              // charts[chart_data.name].update({ yAxis: "left1" });
              // console.log(charts);
            }
            let chartsList2 = [];

            for (const key in charts) {
              const ch = charts[key];
              let [tech, node, kpi, bucket, start, end, scope] = ch.name.split("|");
              // console.log("c", ch);
              chartsList2.push({
                id: ch.name,
                tech: tech,
                node: node,
                kpi: kpi,
                bucket: bucket,
                start: start,
                end: end,
                color: ch.color,
                xAxis: ch.xAxis.userOptions.id,
                yAxis: ch.yAxis.userOptions.id,
                type: "spline",
                "times": times,
                startDate: startDate,
                endDate: endDate,
                scope: scope,
                min: ch.yAxis.min,
                max: ch.yAxis.max
              });
            }
            setCharts(charts);
            setChartsList(chartsList2);
            // console.log(charts);

          }).catch((e) => {
            toast.current.show({ severity: 'error', summary: 'Error Message', detail: 'Fech kpi faild' });
            // console.log(e);
            setPlayLoading(false);
            chartRef.current.chart.hideLoading();
          }
          )
        }
        else {
          // console.log("kpi removed");
        }
      }


    }
    else {
      toast.current.show({ severity: 'info', summary: 'Error Message', detail: 'Select All conditions' });
    }
  }
  const FetchKpiDownload = (ag_level) => {
    if (selectedNodes && selectedKPI && Date.parse(startDate) && Date.parse(endDate) && value_ag.value) {
      setdownloadLoading(true);
      const [vendor, tech, level] = selectedKey.split("-");
      const start_mini = strftime("%m-%d", new Date(startDate));
      const end_mini = strftime("%m-%d", new Date(endDate));
      const date_mini = start_mini + "|" + end_mini;

      let newNode = new Set();
      let newKPI = new Set();
      for (const kpi of selectedKPI) {
        for (const node of selectedNodes) {
          newNode.add(node);
          newKPI.add(kpi);
        }
      }
      // console.log(selectedTimes);
      if (newNode.size !== 0 && newKPI.size !== 0) {
        let times = []
        selectedTimes.forEach(d => times.push(d.name));
        let data = {
          "buket": value_ag.value,
          "startDate": startDate,
          "endDate": endDate,
          "scope": level,
          "ne_list": Array.from(newNode),
          "kpi_id": Array.from(newKPI),
          "tech": tech,
          "times": times,
          "ag": checkedAggregate,
          "ag_level": ag_level
        };
        console.log(data);
        // console.log("newKPI", newKPI);
        // chartRef.current.chart.showLoading();
        performanceManagementService.PostBlob("/kpi2RDownload", data).then((response) => {
          const href = URL.createObjectURL(new Blob([response.data],
            { type: 'application/x-zip-compressed' }));

          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', 'export.zip'); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          setdownloadLoading(false);
        }).catch((e) => {
          toast.current.show({ severity: 'error', summary: 'Error Message', detail: 'Fech kpi faild' });
          console.log(e);
          setdownloadLoading(false);
        }
        )
      }
      else {
        // console.log("kpi removed");
      }

    }
  }
  // useEffect(() => {

  // }, [selectedNodes, selectedKPI, startDate, endDate, value_ag]);
  const [kpiTab, setKpiTab] = useState(0);
  useEffect(() => {

    const [vendor, tech, level] = treeValue.split("-");
    if (nodeFilterValue.indexOf(",") > -1) {
      setFilterMatchMode("notEquals");
    }
    else {
      setFilterMatchMode("contains");
    }
    setselectedNodes([]);

    setCheckedAggregate(false);
    setCheckedSelectAll(false);
    const [old_vendor, old_tech, old_level] = selectedKey.split("-");
    setSelectedKey(treeValue)
    // if (tech && old_tech !== tech) {
    if (tech) {
      kpiService.Post("/all", { "tech": tech.toUpperCase(), "operator": "Rightel", tab: kpiTab }, {}).then((response) => {
        // console.log(response)
        setKpiList(response.data);
        setSelectedKPI([]);
      }).catch((e) => {
        console.log(e);
      })
    }
    // console.log("sasadasd", treeValue, nodeFilterValue);
    performanceManagementService.fetchETLR({ "tech": tech, "level": level, "filter": nodeFilterValue }).then((response) => {
      setNodes(response.data);
    })
  }, [treeValue, nodeFilterValue, kpiTab])
  const options2 = ['1W', '2W', '1M', '2M', '3M'];
  const [range, setRange] = useState('1W');

  useEffect(() => {

    let days = 86400000;//number of milliseconds in a day
    let today = new Date(endDate);
    let before = 0;
    switch (range) {
      case "1D":
        before = new Date(today - (1 * days))
        break;
      case "3D":
        before = new Date(today - (3 * days))
        break;
      case "1W":
        before = new Date(today - (7 * days))
        break;
      case "2W":
        before = new Date(today - (14 * days))
        break;
      case "1M":
        before = new Date(today - (30 * days))
        break;
      case "2M":
        before = new Date(today - (60 * days))
        break;
      case "3M":
        before = new Date(today - (90 * days))
        break;
      default:
        before = new Date(today - (7 * days))
        break;
    }
    setStartDate(before);
  }, [range])
  const tab3HeaderTemplate = (options) => {
    const items = [
      {
        label: 'Save To Dashboards', icon: 'pi pi-save', command: () => {
          setShowDahboardDialog(true);
        }
      },
      // { label: 'Delete', icon: 'pi pi-times' },
      // { label: 'Share', icon: 'pi pi-share-alt' }
    ];

    return (
      <SplitButton label="Main" severity="warning" model={items}></SplitButton>
    )
  };
  useEffect(() => {
    if (checkedSelectAll) {
      setselectedNodes(nodes);
    } else {
      setselectedNodes([]);
    }

  }, [checkedSelectAll])

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      Papa.parse(file, {
        header: false,
        complete: function (results) {
          // console.log(results.data);
          let r = results.data.map(a => a[0]);
          r.shift();
          setNodeFilterValue(r.join(","));
          inputRef.current.value = null;
        }
      });
    };

  };
  const inputRef = useRef(null);
  const startContent = (
    <React.Fragment>
      <Button icon="pi pi-plus " className="p-button-sm text-xs ml-1 h-10`" />

    </React.Fragment>
  );
  // /chartRef.current.chart.xAxis[0].removePlotLine(selectePoint);
  const [chartShared, setChartShared] = useState("Yes");
  const [chartLayout, setChartLayout] = useState("vertical");
  const [chartAlign, setChartAlign] = useState("center");
  const [chartverticalAlign, setChartverticalAlign] = useState("top");
  const chartLayoutOptions = ["horizontal", "vertical"];
  const chartverticalAlignOptions = ["top", "middle", "bottom"];
  const chartAlignOptions = ["left", "center", "right"];
  const chartSharedOptions = ["Yes", "No"];
  const [visibleRight, setVisibleRight] = useState(false);
  const [sectionName, setSectionName] = useState("");
  const [sectionDuration, setSectionDuration] = useState("");
  const [sectionAccess, setSectionAccess] = useState("");
  const [dashboards, setDashboards] = useState([]);
  const [selectedDashboard, setSelectedDashboard] = useState([]);
  //setLineOrientation
  const [lineOrientation, setLineOrientation] = useState([]);
  useEffect(() => {
    if (showDahboardDialog) {
      performanceManagementService.rightel_dashboard_list({}).then((response) => {
        console.log(response.data);
        setDashboards(response.data);
      }).catch(e => {
        toast.current.show({ severity: 'error', summary: 'Error Message', detail: 'Fech dashboards faild' });
      })
    }
  }, [showDahboardDialog])
  const chartOptionsClick = (cAlign) => {
    chartRef.current.chart.legend.options.align = cAlign;
    setChartAlign(cAlign);
  };
  useEffect(() => {
    // console.log(chartAlign);
    chartRef.current.chart.tooltip.shared = chartShared;
    // chartRef.current.chart.legend.options.layout = chartLayout;
    // chartRef.current.chart.legend.options.align = chartAlign;
    // console.table(chartRef.current.chart.legend.options);

    // chartRef.current.chart.legend.options.verticalAlign = chartverticalAlign;
  }, [chartShared]);
  const itemsDownload = [
    {
      label: 'Cell',

      command: () => {
        FetchKpiDownload('Name');
      }
    },
    {
      label: 'Sector',

      command: () => {
        FetchKpiDownload('Sector');
      }
    },
    {
      label: 'Site',

      command: () => {
        FetchKpiDownload('Site');
      }
    }
  ];

  const kpiTemplate = (option) => {
    return (
      <div className="align-middle" >
        <Button icon="pi pi-star-fill" className="p-button-sm text-xs ml-1 h-10" severity="secondary" rounded text />
        {option.name}
      </div>
    );
  };
  return (
    <div className="flex pt-16 relative  flex-grow h-full ">
      <div className={`h-16 transition-all duration-300 absolute top-0 z-20 w-full flex flex-col bg-white border-b border-gray-200 overflow-hidden `} >
        <div className="flex  bg-white rounded-xl p-3 ">


          {/* <Calendar value={dates} dateTemplate={dateTemplate} required showButtonBar className="p-inputtext-sm text-sm" o
          nChange={(e) => setDates(e.value)} selectionMode="range" readOnlyInput /> */}
          {/* <SelectButton value={value_ag} onChange={(e) => setag(e.value)} optionLabel="name" options={ag_items} className=""/> */}
          <RadioGroupBtn value={value_ag} onChange={(e) => setag(e)} options={ag_items} optionLabel="name" optionValue="value" className="btn-container align-center justify-center border" ></RadioGroupBtn>
          {/* <SelectButton value={range} onChange={(e) => setRange(e.value)} options={options2} className="ml-1 justify-center p-button-help" /> */}
          <RadioGroupBtn value={range} onChange={(e) => setRange(e)} options={options2} className="btn-container align-center justify-center border ml-2"></RadioGroupBtn>

          <Button icon="pi pi-play" severity="success" tooltip="Draw Chart" onClick={FetchKpi} loading={playLoading} className=" p-button-sm text-xs ml-2 h-10" text raised aria-label="Filter" />
          {/* <Button icon="pi pi-cloud-download" severity="success" tooltip="Download RAW data" loading={downloadLoading} onClick={FetchKpiDownload} className=" p-button-sm text-xs ml-2 h-10" text raised aria-label="Filter" /> */}
          <SplitButton icon="pi pi-cloud-download" severity="success" tooltip="Download RAW data" loading={downloadLoading} className=" p-button-sm text-xs ml-2 h-10" text raised aria-label="Filter" model={itemsDownload} />
          {/* <Button icon="pi pi-play" rounded outlined aria-label="Filter" /> */}
          <Button className=" p-button-sm text-xs ml-1 h-10 " raised icon="pi pi-cog" tooltip="Chart Setting" onClick={() => setDialogVisible(true)} />
          <Button className=" p-button-sm text-xs ml-1 h-10" raised icon="pi pi-clock" tooltip="Select Hours" onClick={() => setTimeDialogVisible(true)} />
          <Button className=" p-button-sm text-xs ml-1 h-10" raised icon="pi pi-pencil" severity={drawLine} tooltip="Draw Line" onClick={() => drawLine === "secondary" ? setDrawLine("success") : setDrawLine("secondary")} />
          <Button className=" p-button-sm text-xs ml-1 h-10" raised icon={showAllSeries ? 'pi pi-eye' : 'pi pi-eye-slash'} onClick={toggleSeriesVisibility} tooltip="Hide/Show All" severity="warning" />
          <Button className=" p-button-sm text-xs ml-1 h-10" raised icon={chartShared ? 'pi pi-sliders-h' : 'pi pi-sliders-v'} onClick={(e) => setChartShared(!chartShared)} tooltip="Chart tooltip shared" severity="warning" />

          <Calendar id="calendar-24h" className="md:w-14rem text-xs text-container size ml-1 w-40 right-0 " value={startDate} inputRef={calendarStartRef} dateFormat="yy-mm-dd" showButtonBar onChange={(e) => setStartDate(e.value)} showTime hourFormat="24" />
          <Calendar id="calendar-24h" className="md:w-14rem text-xs text-container size ml-1 w-40" value={endDate} inputRef={calendarEndRef} dateFormat="yy-mm-dd" visible={true} showButtonBar onChange={(e) => setEndDate(e.value)} showTime hourFormat="24" />
          <Button className=" p-button-sm text-xs ml-1 h-10" raised onClick={clearChart} severity="danger" tooltip="Clear Chart" icon="pi pi-eraser" />

          {/* <Button label="1D" className="text-xs ml-2 justify-center self-center w-8 h-8 p-button-secondary" onClick={(e) => rangeButtonClick("1D")} />
          <Button label="3D" className="text-xs ml-1 justify-center self-center w-8 h-8 p-button-secondary" onClick={(e) => rangeButtonClick("3D")} /> */}
          {/* <Button label="1W" className="ml-1 justify-center  p-button-info w-8 h-8 " onClick={(e) => rangeButtonClick("1W")} />
          <Button label="2W" className="ml-1 justify-center  p-button-info w-8 h-8 " onClick={(e) => rangeButtonClick("2W")} />
          <Button label="1M" className="ml-1 justify-center  p-button-info w-8 h-8 " onClick={(e) => rangeButtonClick("1M")} /> */}
          {/* <Button className="pi pi-chart-line text-xs ml-1 h-10" severity="success" onClick={() => setVisibleRight(true)} /> */}
          <Button className=" p-button-sm text-xs ml-1 h-10" raised icon="pi pi-save" severity="success" tooltip="Save to dashboard" onClick={() => setShowDahboardDialog(true)} />
          <Message severity="info" text={timeSpan} className="text-xs ml-1 h-10" />

          {/* <SelectButton value={value_vendor} onChange={(e) => setVendor(e.value)} className=" p-button-sm text-xs" optionLabel="name" options={vendor_items} />
          <SelectButton value={value_tec} onChange={(e) => settec(e.value)} className=" p-button-sm text-xs" optionLabel="name" options={items} />
          <SelectButton value={value_ph} onChange={(e) => setPH(e.value)} className=" p-button-sm text-xs" optionLabel="name" options={r_items} /> */}
        </div>

      </div>

      <div className="flex flex-grow relative w-full">
        {/* <div className="w-70 flex-shrink-0 bg-white border-r border-gray-200 overflow-auto ">
          <div className={classNames("bg-white rounded-xl ", "focus:outline-none")}>
            <div className="card flex justify-content-center bg-white w-full">
              <Tree selectionMode="single" selectionKeys={selectedKey} onSelectionChange={(e) => setTreeValue(e.value)} value={tree} className="w-full  md:w-30rem text-xs text-container" />
            </div>
          </div>
        </div> */}
        <div className="w-80 flex-shrink-0 bg-white border-r border-gray-200 overflow-auto">
          <div className={classNames("bg-white rounded-xl p-1  ", "focus:outline-none")}>
            <TreeSelect value={selectedKey} onChange={(e) => setTreeValue(e.value)} options={tree}
              className="w-full md:w-14rem text-xs text-container size" placeholder="Start Here" ></TreeSelect>
          </div>
          <div className={classNames("bg-white rounded-xl p-1  ", "focus:outline-none")}>
            <TabView activeIndex={kpiTab} onTabChange={(e) => setKpiTab(e.index)} style={{ padding: 0 }}>
              <TabPanel header="I" leftIcon="pi pi-microsoft mr-2">

              </TabPanel>
              <TabPanel header="II" rightIcon="pi pi-user ml-2">

              </TabPanel>
              <TabPanel header="III" leftIcon="pi pi-search mr-2" rightIcon="pi pi-cog ml-2">

              </TabPanel>
            </TabView>
            <ListBox
              multiple
              tooltip="Search For KPI"
              filter
              // itemTemplate={kpiTemplate}
              value={selectedKPI}
              className="w-fit  text-xs text-container m-0"
              listStyle={{ maxHeight: '250px', margin: 0 }}
              onChange={(e) => setSelectedKPI(e.value)} options={kpiList}
              optionLabel="name" />
          </div>
          <div className={`h-16 transition-all w-full flex flex-col bg-white border-b border-gray-200 overflow-hidden `} >
            <div className="flex  bg-white rounded-xl p-3 ">

              <input id="file" ref={inputRef} type="file" accept=".csv" onChange={handleFileUpload} style={{ width: '0.1px', height: '0.1px', opaCity: 0 }} />
              <label className="pi pi-plus ml-2 mr-9" style={{ fontSize: '1rem' }} for="file"></label>
              {/* <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} /> */}

              <Checkbox onChange={e => setCheckedSelectAll(e.checked)} tooltip="Select All" className="form-checkbox ml-1 h-4 w-5 text-gray-600" label checked={checkedSelectAll}></Checkbox>
              <label className="ml-1 h-4 w-5">All</label>

              <Checkbox onChange={e => setCheckedAggregate(e.checked)} tooltip="Aggregate selected Item" className="form-checkbox ml-1 h-4 w-5 text-gray-600" checked={checkedAggregate}></Checkbox>
              <label className="ml-1 h-4 w-5" >Agg</label>

            </div></div>
          <div className={classNames("bg-white rounded-xl p-1", "focus:outline-none")}>

            <ListBox
              multiple
              filter
              filterMatchMode={filterMatchMode}
              value={selectedNodes}
              className="w-full md:w-14rem text-xs text-container size"
              listStyle={{ maxHeight: '250px' }}
              filterValue={nodeFilterValue}
              // filterTemplate={listBoxHeaderTemplate}
              onFilterValueChange={(e) => nodeOnFilterValueChange(e.value)}
              onChange={(e) => setselectedNodes(e.value)} options={nodes}
            />
          </div>
        </div>
        <div className="flex w-full">
          <div className=" h-full w-full">
            <div style={{ height: "100%" }}>
              {/* <TabView>
                <TabPanel headerTemplate={tab3HeaderTemplate}> */}

              <HighchartsReact
                ref={chartRef}
                highcharts={Highcharts}
                options={options}
                updateArgs={[true, false, true]}
                containerProps={{ style: { height: 'calc(100vh - 250px)', width: '100%' } }}
                onClick={onChartClick}
              />



              {/* </TabPanel>
              </TabView> */}

            </div>
          </div>
        </div>
        {/* tech:tech,
              node:node,
              kpi:kpi,
              bucket:bucket,
              start:start,
              end:end, */}
        <Dialog visible={dialogVisible} maximizable
          modal onHide={() => setDialogVisible(false)} footer={dialogFooterTemplate}>
          <DataTable value={chartsList} scrollable scrollHeight="flex" tableStyle={{ minWidth: '50rem' }}>
            <Column body={deleteTemplate}  ></Column>
            <Column field="tech" header="tech"></Column>
            <Column field="node" header="node"></Column>
            <Column field="kpi" header="kpi"></Column>
            <Column field="bucket" header="Level"></Column>
            <Column field="start" header="start"></Column>
            <Column field="end" header="end"></Column>
            <Column field="color" body={colorTemplate} header="Color"></Column>
            <Column field="yAxis" editor={(props) => yAxisEditor(props)} header="yAxis"></Column>
            <Column field="xAxis" editor={(props) => xAxisEditor(props)} header="xAxis"></Column>
            <Column field="type" editor={(props) => typeEditor(props)} header="Type"></Column>
            <Column field="min" editor={(props) => minMaxEditor(props, "min")} header="min"></Column>
            <Column field="max" editor={(props) => minMaxEditor(props, "max")} header="max"></Column>
            <Column body={exportTemplate}  ></Column>


          </DataTable>
        </Dialog>
        <Dialog visible={timeDialogVisible} maximizable modal onHide={() => setTimeDialogVisible(false)} footer={dialogTimeFooterTemplate}>
          <div className="grid grid-cols-4 gap-4">
            {times.map((category) => {
              return (
                <div>
                  <Checkbox inputId={category.name} name="category" value={category} onChange={onCategoryChange}
                    checked={selectedTimes.some((item) => item.name === category.name)} />
                  <label htmlFor={category.name} className="ml-2">
                    {category.name}
                  </label>
                </div>
              );
            })}
          </div>
        </Dialog>
        <Dialog visible={showDahboardDialog} maximizable modal onHide={() => setShowDahboardDialog(false)} header="Add Chart to Dashboard" footer={dialogSaveChartToDashboard}>
          <div class="mb-6">
            <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Section Name</label>
            <InputText value={sectionName} onChange={(e) => setSectionName(e.target.value)} />

          </div>
          <div class="mb-6">
            <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Time Range</label>
            <Dropdown optionLabel="name" value={sectionDuration} options={[
              { name: '1 Week', code: "7" },
              { name: '2 Weeks', code: "14" },
              { name: '4 Weeks', code: "28" },
              { name: '1 Month', code: "30" },
              { name: '2 Month', code: "60" },
              { name: '3 Month', code: "90" },
              { name: '1 Year', code: "365" },
            ]} onChange={(e) => setSectionDuration(e.value)} className="w-full md:w-14rem" />
          </div>
          {/* <div class="mb-6">
            <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Access Type</label>
            <Dropdown optionLabel="name" value={sectionAccess} options={[
              { name: 'Private' },
              { name: 'Public' },
            ]} onChange={(e) => setSectionAccess(e.value)} className="w-full md:w-14rem" />
          </div> */}
          <div class="mb-6">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Add Section to </label>
            <Dropdown editable optionLabel="name" value={selectedDashboard} options={dashboards} onChange={(e) => setSelectedDashboard(e.value)} className="w-full md:w-14rem" />
            <small id="username-help">
              Select a dashboard or type name for new dashboard.
            </small>
          </div>

        </Dialog>
        <Dialog visible={showLineDialog} maximizable modal onHide={() => setShowLineDialog(false)} header="Add Line" footer={dialogLineFooterTemplate}>
          <div class="mb-6">
            <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Label</label>
            <InputText value={lineLabel.text} onChange={(e) => setLineLabel(x => { x.text = e.target.value })} />
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Label align</label>
            <Dropdown optionLabel="name" value={lineLabel.align} options={[
              { name: 'left' },
              { name: 'center' },
              { name: 'right' },
            ]} onChange={(e) => setLineLabel(x => { x.align = e.value })} className="w-full md:w-14rem" />
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Label verticalAlign</label>
            <Dropdown optionLabel="name" value={lineLabel.verticalAlign} options={[
              { name: 'top' },
              { name: 'middle' },
              { name: 'bottom' },
            ]} onChange={(e) => setLineLabel(x => { x.verticalAlign = e.value })} className="w-full md:w-14rem" />
            <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Horizontal position</label>
            <Slider value={lineLabel.x} min={-100} max={100} onChange={(e) => setLineLabel(x => { x.x = e.value })} className="w-14rem" />
            <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Vertical position</label>
            <Slider value={lineLabel.y} min={-100} max={100} onChange={(e) => setLineLabel(x => { x.y = e.value })} className="w-14rem" />
          </div>


          <div class="mb-6">
            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Line Style</label>
            <Dropdown optionLabel="name" value={newLineDashStyle} options={[
              { name: 'dash' },
              { name: 'dashdot' },
              { name: 'Dot' },
              { name: 'LongDash' },
              { name: 'LongDashDot' },
              { name: 'LongDashDotDot' },
              { name: 'ShortDash' },
              { name: 'ShortDashDot' },
              { name: 'ShortDashDotDot' },
              { name: 'ShortDot' },
              { name: 'Solid' },
            ]} onChange={(e) => setNewLineDashStyle(e.value)} className="w-full md:w-14rem" />
            <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Line Orientation</label>
            <Dropdown optionLabel="name" value={lineOrientation} options={selectePoint} onChange={(e) => setLineOrientation(e.value)} className="w-full md:w-14rem" />
            <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Line Color</label>
            <ColorPicker value={newLineColor} onChange={(e) => setNewLineColor(e.value)} />

          </div>
          <div class="mb-6">
            <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Width</label>
            <Slider value={newLineWidth} min={2} max={10} onChange={(e) => setNewLineWidth(e.value)} className="w-14rem" />
          </div>
        </Dialog>
        <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <div class="flex flex-col mt-3">
            <label class=" basis-1/4 block mb-2 text-sm font-medium text-gray-900 dark:text-white">tooltip shared</label>
            <SelectButton value={chartShared} onChange={(e) => setChartShared(e.value)} options={chartSharedOptions} />
            <label class=" basis-1/4 block mb-2 text-sm font-medium text-gray-900 dark:text-white">legend align</label>
            <SelectButton value={chartAlign} onChange={(e) => chartOptionsClick(e.value)} options={chartAlignOptions} />
            <label class=" basis-1/4 block mb-2 text-sm font-medium text-gray-900 dark:text-white">legend layout</label>
            <SelectButton value={chartLayout} onChange={(e) => setChartLayout(e.value)} options={chartLayoutOptions} />
            <label class=" basis-1/4 block mb-2 text-sm font-medium text-gray-900 dark:text-white">legend verticalAlign</label>
            <SelectButton value={chartverticalAlign} onChange={(e) => setChartverticalAlign(e.value)} options={chartverticalAlignOptions} />
          </div>
        </Sidebar>
        <Toast ref={toast} />
      </div>
    </div >
  );
}

export default Queries2;




